import React from 'react';

const LinearFitIcon = ({ size = 40, className = '' }) => (
  <svg
    viewBox="0 0 100 100"
    width={size}
    height={size}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(0, 0)">
      {/* Lineare Ausgleichsgerade */}
      <line x1="10" y1="80" x2="90" y2="40" stroke="#f3f4f6" strokeWidth="6" />

      <line x1="20" y1="40" x2="20" y2="70" stroke="#f3f4f6" strokeWidth="4" strokeDasharray="4" />
      <line x1="50" y1="20" x2="50" y2="60" stroke="#f3f4f6" strokeWidth="4" strokeDasharray="4" />
      <line x1="80" y1="80" x2="80" y2="50" stroke="#f3f4f6" strokeWidth="4" strokeDasharray="4" />

      {/* Punkte nahe an der Linie */}
      <circle cx="20" cy="40" r="6" fill="#f3f4f6" />
      <circle cx="50" cy="20" r="6" fill="#f3f4f6" />
      <circle cx="80" cy="80" r="6" fill="#f3f4f6" />
    </g>
  </svg>
);

export default LinearFitIcon;
